export default function RouteMarker({ className = "", label = "US → Mexico relocation guidance" }) {
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="route-marker">
      <span className="flex items-center gap-1.5" aria-hidden="true">
        <span className="h-2 w-2 rounded-full bg-clay" />
        <span className="h-px w-4 bg-clay/50" />
        <span className="h-1.5 w-1.5 rounded-full bg-terracotta" />
        <span className="h-px w-4 bg-sage/50" />
        <span className="h-2 w-2 rounded-full bg-sage" />
      </span>
      <span className="text-xs sm:text-sm uppercase tracking-[0.2em] font-semibold text-clay-700">
        {label}
      </span>
    </div>
  );
}
